export default "__VITE_ASSET__80f8b542__"